(function() {
  'use strict';

  const css = `
    .scroll-animate {
      opacity: 0;
      transform: translateY(24px);
      transition: opacity 0.5s ease, transform 0.5s ease;
    }
    .scroll-animate--visible {
      opacity: 1;
      transform: translateY(0);
    }
  `;

  const style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  const selectors = [
    '.card-wrapper',
    '.product-card-wrapper',
    '.grid__item'
  ];

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('scroll-animate--visible');
      } else {
        entry.target.classList.remove('scroll-animate--visible');
      }
    });
  }, {
    threshold: [0, 0.1, 0.5, 1.0],
    rootMargin: '0px'
  });

  function observeCards() {
    document.querySelectorAll(selectors.join(', ')).forEach((card) => {
      if (!card.classList.contains('scroll-animate')) {
        card.classList.add('scroll-animate');
        observer.observe(card);
      }
    });
  }

  new MutationObserver(observeCards).observe(document.body, {
    childList: true,
    subtree: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCards);
  } else {
    observeCards();
  }

})();
